
/**
 * @method axboot.ajax
 * @param {Object} http
 * @param {String} http.type
 * @param {String} http.url
 * @param {Object|String} http.data
 * @param {Function} http.callback
 * @param {Object} [http.options]
 * @param {Boolean} [http.options.nomask = false]
 * @param {Function} [http.options.onError]
 * @param {String} [http.options.contentType]
 * @param {String} [http.options.apiType]
 * @example
 * ```js
 *  // 기본 에러가 나면 알어서 처리 함.
 *  axboot.ajax({
 *      type: "GET",
 *      url: "/api/v1/users",
 *      data : {},
 *      callback: function(response){
 *          // do something
 *      }
 *  });
 *
 *  // onError 지정
 *  axboot.ajax({
 *      type: "GET",
 *      url: "/api/v1/users",
 *      data : {},
 *      callback: function(response){
 *          // do something
 *      },
 *      options: {
 *          onError: function(err){
 *              // console.log(err);
 *          }
 *      }
 *  });
 * ```
 */
axboot.ajax = function () {
    var queue = [];
    var defaultOption = {
        type        : 'POST',
        contentType : 'application/json; charset=UTF-8'
    };

    return function (http) {
        var jqxhr, httpOpts, callback, unconditionalCallback;
        var options = $.extend(true, {}, defaultOption, http.options);
        if (!options.nomask) axAJAXMask.open();

        queue.push('1');

        httpOpts = {
            type        : options.type,
            contentType : options.contentType,
            url         : http.url,
            unconditionalCallback : http.unconditionalCallback
        };

        $.extend(http, httpOpts);

        callback = http.callback;
        unconditionalCallback = http.unconditionalCallback;

        jqxhr = $.ajax(http);
        jqxhr.done(function (data, textStatus, jqXHR) {
            var executeUserFunc = true;
            var responseType = axboot.util.getResponseType(data);

            if (responseType == 'validation' && data.errorCount > 0) {
                executeUserFunc = false;
            }

            axboot.util.responseResultMsg(data);

            if (data['loginRequired'] && data['redirect']) {
                axDialog.alert({
                    theme: 'danger',
                    title: '인증오류 !',
                    msg: '로그인이 필요합니다. 로그인 페이지로 이동합니다.',
                    width: 500
                }, function () {
                    if (top.loginPage && ax5.util.isFunction(top.loginPage)) {
                        top.loginPage(data['redirectUrl']);
                    } else {
                        top.location.href = data['redirectUrl'];
                    }
                });
    
                return;
            }

            if (executeUserFunc || unconditionalCallback) {
                var args = [].concat($.makeArray(arguments));
                if (callback) callback.apply(this, args); // callback
            }
        }).fail(function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 0) {
                //console.log('# jqXHR.status : Not connect. Verify Network.' + errorThrown);
                //alert('Not connect. Verify Network.');
            } else if (jqXHR.status == 500) {
                axboot.util.responseResultMsg(jqXHR.responseJSON);
            } else if (jqXHR.status == 400
                    || jqXHR.status == 403
                    || jqXHR.status == 404
                    //|| jqXHR.status == 500
                    || jqXHR.status == 503) {
                alert('[' + jqXHR.status + '] - ' + errorThrown);
            } else if (errorThrown === 'parsererror') {
                alert('Requested JSON parse failed.');
            } else if (errorThrown === 'timeout') {
                alert('Time out error.');
            } else if (errorThrown === 'abort') {
                alert('Ajax request aborted.');
            } else {
                alert('[' + jqXHR.status + '] - ' + 'Uncaught Error -> (' + errorThrown + ')\n지속적으로 오류발생시 새로고침을 해보세요.');
                //location.reload(true);
            }

            /*
            if (errorThrown == "") {} else {
                if (callback) callback.apply(this, [{
                    error: { message: msg }
                }]); // callback
            }
            */

            if (!options.nomask) axAJAXMask.close(300);
        }).always(function (data, textStatus, jqXHR) {
            queue.pop();

            // 프레임 셋에 타이머 초기화.
            if (top.fnObj && top.fnObj.activityTimerView) {
                top.fnObj.activityTimerView.update();
            }

            if (!options.nomask) if (queue.length == 0) axAJAXMask.close(300);
        });
    };
}();
